<script>
import DatePicker from "vue2-datepicker";
import MultiSelect from "vue-multiselect";
import moment from "moment";

// Custom Componets
import PageHeader from "@/components/page-header";
import Pagination from "@/components/Pagination.vue";
import iotService from "@/helpers/APIService/iot.service";
import errorHandler from "@/helpers/errorHandler";
import handleLogic from "@/helpers/handleLogic";

export default {
  data() {
    return {
      title: "key Log",
      selectDate: "",
      openDrawer: false,
      keyList: [],
      filter: {
        gateway: { text: "All", value: "all" },
        device: { text: "All", value: "all" },
      },
      gatewayOptions: [{ text: "All", value: "all" }],
      deviceOptions: [{ text: "All", value: "all" }],
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
        currentPage: 0,
      },
      isLoading: false,
      selectedKey: null,
    };
  },
  components: {
    PageHeader,
    Pagination,
    DatePicker,
    MultiSelect,
  },
  mounted() {
    this.getGateways();
    this.getKeyListData();
  },
  methods: {
    addAssignLockDrawer() {
      this.openDrawer = !this.openDrawer;
    },
    // Method is used to get gateway list
    async getGateways() {
      try {
        const response = await iotService.getLockGatewayList();
        if (response) {
          this.getDevices(response[0].id);
          response.map((item) => {
            this.gatewayOptions.push({ text: item.name, value: item.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get device list
    async getDevices(gateway_id) {
      try {
        this.deviceOptions = [{ text: "All", value: "all" }];
        const response = await iotService.getLockDeviceList(gateway_id);
        if (response) {
          response.map((item) => {
            this.deviceOptions.push({ text: item.device_name, value: item.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get key list
    getKeyListData(device_id) {
      this.keyList = [];
      let query = "";
      if (device_id !== "all" && device_id !== undefined) {
        query += `?iot_device=${device_id}`;
      }
      iotService
        .getKeyList(query)
        .then((response) => {
          this.keyList = response.results;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to filter key log
    filterKeyLog(type) {
      if (type == "gateway") {
        if (this.filter.gateway.value == "all") {
          return (this.filter.device = { text: "All", value: "all" });
        }
        this.getDevices(this.filter.gateway.value);
      }
      if (type == "device") {
        this.getKeyListData(this.filter.device.value);
      }
    },
    // Method is used to handle last use
    lastUage(last_usage) {
      return moment(last_usage).fromNow();
    },
    showKeyLogsModal(data) {
      this.selectedKey = data;
      if (data.iot_device) {
        this.getDeviceBasedLogList(`?size=${this.table.size}`);
      }
      this.$refs["reason-modal"].show();
    },
    resetModal() {
      this.$refs["reason-modal"].hide();
    },
    // Method is used to get device based key logs
    async getDeviceBasedLogList(query) {
      const filter =
        `/${this.selectedKey.iot_device.id}` +
        query +
        "&iot_key=" +
        this.selectedKey.id;
      this.isLoading = true;
      try {
        const response = await iotService.getKeyLogList(filter);
        if (response) {
          this.table.tableData = [];
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.currentPage = response.page_number;
          response.results.map((item) => {
            this.handleResponse(item);
          });
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get more guest
    onPageChange(page) {
      this.getDeviceBasedLogList(`?page=${page}&size=100`, "load_more");
    },
    // Method is used to handle response
    handleResponse(item) {
      if (item.topic == "ALARM" || item.topic == "CMD") {
        const data = handleLogic.handleGatewaySocketResponse(item, []);
        this.table.tableData.push(data);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="New Group"
      :isButton="true"
      :action="addAssignLockDrawer"
    />
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-xl-2 col-md-4 col-sm-6">
            <MultiSelect
              :options="gatewayOptions"
              v-model="filter.gateway"
              :show-labels="false"
              :allow-empty="false"
              placeholder="by gateway"
              track-by="value"
              label="text"
              name="gateway"
              @close="filterKeyLog('gateway')"
            />
          </div>
          <div class="col-xl-2 col-md-4 col-sm-6">
            <MultiSelect
              :options="deviceOptions"
              v-model="filter.device"
              :show-labels="false"
              :allow-empty="false"
              placeholder="by device"
              track-by="value"
              label="text"
              name="device"
              @close="filterKeyLog('device')"
            />
          </div>
          <div class="col-xl-2 col-md-4 col-sm-6">
            <date-picker
              lang="en"
              placeholder="Select Date"
              type="date"
              value-type="format"
              v-model="selectDate"
            ></date-picker>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th>key#</th>
                <th>key type</th>
                <th>room</th>
                <th>key holder</th>
                <th>start date</th>
                <th>valid upto</th>
                <th>usage</th>
                <th>last used</th>
                <th>issued by</th>
                <th>issued date</th>
                <th>status</th>
              </tr>
            </thead>
            <tbody v-for="(key, index) in keyList" :key="index">
              <tr @click="showKeyLogsModal(key)" class="cursor">
                <td>
                  {{
                    key.key_type == "rfid" && key.rfid_card_id != null
                      ? key.rfid_card_id
                      : key.key_type == "mobile" && key.mobile != null
                      ? key.mobile
                      : key.key_code
                  }}
                </td>
                <td class="text-capitalize">
                  {{ key.key_type }}
                </td>
                <td>{{ key.room.room_number }}</td>
                <td>
                  {{
                    key.user_levey_type == "guest"
                      ? key.booking
                        ? key.booking.first_name + " " + key.booking.last_name
                        : "-"
                      : key.assigned_to
                      ? key.assigned_to.first_name +
                        " " +
                        key.assigned_to.last_name
                      : "-"
                  }}
                </td>
                <td>
                  {{
                    global_format_date_and_time_custom(
                      key.start_datetime,
                      "DD-MM-YYYY HH:mm"
                    )
                  }}
                </td>
                <td>
                  {{
                    global_format_date_and_time_custom(
                      key.expire_datetime,
                      "DD-MM-YYYY HH:mm"
                    )
                  }}
                </td>
                <td>{{ key.total_usage }}</td>
                <td>
                  {{ key.last_used_at ? lastUage(key.last_used_at) : "-" }}
                </td>
                <td>{{ key.created_by ? key.created_by : "-" }}</td>
                <td>
                  {{
                    global_format_date_and_time_custom(
                      key.created_at,
                      "DD-MM-YYYY HH:mm"
                    )
                  }}
                </td>
                <td
                  class="badge py-1 px-1 card-badge mt-2 me-2"
                  :class="
                    !key.is_active ? 'badge-soft-warning' : 'badge-soft-success'
                  "
                >
                  {{ key.is_active ? "Active" : "Inactive" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal
      id="reason-modal"
      centered
      :title="`
        ROOM ${
          selectedKey && selectedKey.room ? selectedKey.room.room_number : ''
        } KEY LOGS`"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      ref="reason-modal"
      size="xl"
    >
      <div class="table-responsive">
        <v-table
          :data="table.tableData"
          class="table table-hover mb-0"
          ref="my-table"
        >
          <thead class="table-light" slot="head">
            <tr>
              <th class="w-25">timestamp</th>
              <th class="w-25">Events</th>
              <th class="w-25">User</th>
              <th class="w-25">Remark</th>
            </tr>
          </thead>
          <tbody
            class="infinite-list"
            slot="body"
            slot-scope="{ displayData }"
            v-if="!isLoading && table.tableData.length !== 0"
          >
            <tr v-for="(log, index) in displayData" :key="index">
              <td>
                {{
                  global_format_date_and_time_custom(
                    log.created_at,
                    "YYYY-MM-DD hh:mm a"
                  )
                }}
              </td>
              <td>
                {{ log.event }}
              </td>
              <td class="text-capitalize">{{ log.user_type }}</td>
              <td v-if="log.remark !== '-'">
                <div v-html="log.remark"></div>
              </td>
              <td v-else>-</td>
            </tr>
          </tbody>
          <tbody slot="body" v-else-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 4" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody slot="body" v-else>
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </v-table>
        <Pagination
          v-if="table.previous !== null || table.next !== null"
          :totalPages="table.totalPages"
          :currentPage="table.currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </b-modal>
  </div>
</template>
